import {
  GET_FIELDS_BY_FORM_ID,
  GET_FORMS_FIELDS,
  UPDATE_ONE_FIELDS,
  UPDATE_FIELDS,
  ADD_FIELD,
  GET_ONE_FIELD,
  GET_SECTIONS,
  GET_ALL_FIELDS,
  GET_ALL_FLAG,
  GET_ALL_LABEL_FIELDS,
  GET_ALL_ADMIN_FLAG,
  GET_ALL_ADMIN_FIELD,
} from '../types'

const INITIAL_STATE = {
  getFieldByFormId: [],
  allForms: [],
  reqFields: [],
  updateField: [],
  updateOneField: [],
  oneField: {},
  addFields: [],
  allFields: [],
  allSections: [],
  allFlagFields: [],
  allLabelFields: [],
  adminFlagFields: [],
  adminFields: [],
}

const fieldReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case GET_FORMS_FIELDS:
      const { forms } = payload.data || {}
      const reqFields =
        forms?.flatMap(({ section }) =>
          section.flatMap(({ fields }) =>
            fields.filter(({ isRequired }) => isRequired),
          ),
        ) || []

      return {
        ...state,
        allForms: payload.data,
        reqFields,
      }
    case GET_FIELDS_BY_FORM_ID:
      return {
        ...state,
        getFieldByFormId: payload.data,
      }
    case ADD_FIELD:
      return {
        ...state,
        addFields: payload.data,
      }
    case UPDATE_FIELDS:
      return {
        ...state,
        updateField: payload.fieldId,
      }
    case UPDATE_ONE_FIELDS:
      return {
        ...state,
        updateOneField: payload.fieldId,
      }
    case GET_ALL_FIELDS:
      return {
        ...state,
        allFields: payload.data,
      }
    case GET_ALL_FLAG:
      return {
        ...state,
        allFlagFields: payload.data,
      }
    case GET_ALL_ADMIN_FLAG:
      return {
        ...state,
        adminFlagFields: payload,
      }
    case GET_ALL_ADMIN_FIELD:
      return {
        ...state,
        adminFields: payload,
      }
    case GET_ALL_LABEL_FIELDS:
      return {
        ...state,
        allLabelFields: payload.data,
      }
    case GET_ONE_FIELD:
      return {
        ...state,
        oneField: payload.data,
      }
    case GET_SECTIONS:
      return {
        ...state,
        allSections: payload.data,
      }
    default:
      return state
  }
}

export default fieldReducer
